export const formatRatePlanChartData = (bookedBookings, cancelledBookings) => {
  const bookedRatePlans = bookedBookings.reduce((acc, booking) => {
    booking.rooms.forEach((room) => {
      const ratePlan = room.ratePlanName || "Unknown";
      acc[ratePlan] = (acc[ratePlan] || 0) + 1;
    });
    return acc;
  }, {});
  const cancelledRatePlans = cancelledBookings.reduce((acc, booking) => {
    booking.rooms.forEach((room) => {
      const ratePlan = room.ratePlanName || "Unknown";
      acc[ratePlan] = (acc[ratePlan] || 0) + 1;
    });
    return acc;
  }, {});

  const allRatePlans = [
    ...new Set([
      ...Object.keys(bookedRatePlans),
      ...Object.keys(cancelledRatePlans),
    ]),
  ];
  const sortedRatePlans = allRatePlans.sort((a, b) => {
    const totalA = (bookedRatePlans[a] || 0) + (cancelledRatePlans[a] || 0);
    const totalB = (bookedRatePlans[b] || 0) + (cancelledRatePlans[b] || 0);
    return totalB - totalA;
  });

  const bookedData = sortedRatePlans.map(
    (ratePlan) => bookedRatePlans[ratePlan] || 0
  );
  const cancelledData = sortedRatePlans.map(
    (ratePlan) => cancelledRatePlans[ratePlan] || 0
  );

  return {
    labels: sortedRatePlans,
    datasets: [
      {
        label: "Booked",
        data: bookedData,
        backgroundColor: "rgba(0, 128, 128, 0.6)",
        borderColor: "rgba(0, 128, 128, 1)",
        borderWidth: 1,
      },
      {
        label: "Cancelled",
        data: cancelledData,
        backgroundColor: "rgba(0, 102, 204, 0.6)",
        borderColor: "rgba(0, 102, 204, 1)",
        borderWidth: 1,
      },
    ],
  };
};
